<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

import simplebar from "simplebar-vue";
//import WalletBalance from "./wallet-balance.vue";

import {
  walletRadialChart,
  // overviewChart,
  transactionsData,
  bitconinChart,
  ethereumChart,
  litecoinChart,
} from "./data";

import ApiClass from "../../../api/api";
/**
 * Crypto Dashboard Component
 */
export default {
  page: {
    title: "Crypto Dashboard",
    meta: [{ name: "description", content: appConfig.description }],
  },

  components: {
    Layout,
    PageHeader,
    //WalletBalance,
    simplebar,
  },
  data() {
    return {
      id: "",
      walletRadialChart: walletRadialChart,
      // overviewChart: overviewChart,
      transactionsData: transactionsData,
      bitconinChart: bitconinChart,
      ethereumChart: ethereumChart,
      litecoinChart: litecoinChart,
      largeImg: "",

      title: "User Profile",
      items: [
        {
          text: "Dashboards",
          href: "/admin",
        },
        {
          text: "Crypto",
          active: true,
        },
      ],
      userInfo: [],
      userKyc: [],
      walletInfo: [],
      cryptoInfo: [],
      ActivityLogsInfo : [],
      sendCryptosInfo : [],
      transferCryptosInfo: [],
      userListData: [],
      totalDeposit: 0,
      totalsendCryptos:[],
      totalreceiveCryptos: [],
      totalTodayWithdraw :0,
        totalWithdraw: 0,
        totalOrders:0,
        totalRefferals: 0,
        totalStaking:0,
        stakingInfo : [],
      ordersInfo: [],
      walletTransactionInfo: [],
      depositTransactionInfo: [],
      loading: true,
    };
  },
  mounted() {
    this.id = this.$route.params.id;
    this.userList();
  },
  methods: {
    async refresh() {
      this.userList();
    },
    async userList() {
      var result = await ApiClass.getRequest(
        "admin/users/get/" + this.id,
        true
      );
      if (result.data.status_code == 1) {
        this.userListData = result.data.data;
        this.userInfo = this.userListData.user;
        this.userKyc = this.userListData.userKyc;
        this.walletInfo = this.userListData.wallet;
        this.cryptoInfo = this.userListData.crypto;
        this.ordersInfo = this.userListData.orders;
        this.stakingInfo = this.userListData.staking;
        this.transferCryptosInfo = this.userListData.transferCryptos;
        this.sendCryptosInfo = this.userListData.sendCryptos;
        this.walletTransactionInfo = this.userListData.walletTransaction;
        this.ActivityLogsInfo = this.userListData.activityLogs;
        this.depositTransactionInfo = this.userListData.depositTransaction;
        this.totalDeposit = this.userListData.totalDeposit;
        this.totalssendCryptos = this.userListData.totalsendCryptos;
        this.totalsreceiveCryptos = this.userListData.totalreceiveCryptos;
        this.totalTodayWithdraw = this.userListData.totalTodayWithdraw;
        this.totalWithdraw = this.userListData.totalWithdraw;
        this.totalsendCryptos = this.userListData.sendCryptos;
        this.totalreceiveCryptos = this.userListData.receiveCryptos;
        this.totalOrders = this.userListData.totalOrders;
        this.totalRefferals = this.userListData.totalRefferals;
        this.totalStaking = this.userListData.totalStaking;

        this.loading = false;
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div v-if="loading" class="d-flex justify-content-center my-5">
  <div class="spinner-border" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
    <div v-else class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            
            <b-tabs content-class="p-3 text-muted">
              <b-tab @click="refresh()" active>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-home"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Overview</span>
                </template>
                <div class="row">
                  <div class="col-xl-4">
                    <div class="card overflow-hidden">
                      <div class="bg-soft bg-info">
                        <div class="row">
                          <div class="col-8">
                            <div class="text-primary p-3">
                              <h5 class="text-primary"> UID :  {{ userInfo.username }} <span
              :class="userInfo.status == 1 ? 'badge bg-success' : 'badge bg-danger'"
              >{{
                userInfo.status == 1 ? "active" : "blocked"
              }}</span
            ></h5>
                  <p class="text-secondary"> <i class="fas fa-clock"></i>  {{
                                    new Date(
                                      userInfo.created_at
                                    ).toLocaleString()
                                  }}</p>
                                  
                 
                               <ul class='nav'> 
                                <li class="position-relative nav-link p-2"><i class="fa fa-fingerprint fa-2x"> </i>
                                  <i class='bx bx-loader-circle text-warning position-absolute top-2' v-if="userInfo.user_kyc_status=='new'"></i> 
                                  <i class='fas fa-check-circle text-success position-absolute top-2' v-else-if="userInfo.user_kyc_status=='completed'"></i> 
                               
                                  <i v-else class='fas fa-times-circle text-danger'></i>
                                </li>
                                <li class="position-relative nav-link p-2"><img src="https://upload.wikimedia.org/wikipedia/commons/6/6e/Google_Authenticator_for_Android_icon.svg" width=30/> 
                                  <i class='bx bxs-check-circle text-success position-absolute top-2' v-if="userInfo.google2fa==1"></i> 
                                    <i v-else class='fas fa-times-circle text-danger'></i>
                                </li>

                                <li class="position-relative nav-link p-2"><i class="fa fa-envelope fa-2x"> </i>
                                  <i class='bx bxs-check-circle text-success position-absolute top-2' v-if="userInfo.email_otp=1"></i> 
                                    <i v-else class='fas fa-times-circle text-danger'></i>
                                </li>
                                <li class="position-relative nav-link p-2"><i class="fa fa-phone fa-2x"> </i>
                                  <i class='bx bxs-check-circle text-success position-absolute top-2' v-if="userInfo.sms_otp=1"></i> 
                                    <i v-else class='fas fa-times-circle text-danger'></i>
                                </li>
                               </ul>
            
                            </div>
                          </div>
                          <div class="col-4 align-self-end">
                            <img
                              src="@/assets/images/profile-img.png"
                              alt
                              class="img-fluid"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="card-body p-0">
                      

                        <div class="table-responsive p-0 m-0">
                          <table class="table table-nowrap mb-0">
                            <tbody>
                            
                              <tr>
                                <th scope="row">Full Name :</th>
                                <td>{{ userInfo.name? userInfo.name : "-" }}</td>
                            
                              </tr>
                              
                              <tr>
                                <th scope="row">Mobile :</th>
                                <td v-if="userInfo.mobile">
                                  +{{ userInfo.country_calling_code }}-{{ userInfo.mobile }}
                                  <i class='fas fa-check-circle text-success' v-if="userInfo.mobile_verified_at"></i> 
                                   <p class="small text-secondary m-0"  v-if="userInfo.mobile_verified_at"> {{  new Date(
                                      userInfo.mobile_verified_at
                                    ).toLocaleString()}}</p>
                                    <i v-else class='fas fa-times-circle text-danger'></i>
                                 
                                </td>
                                <td v-else> -</td>
                              </tr>
                              <tr>
                                <th scope="row">E-mail :</th>
                                <td v-if="userInfo.email">{{ userInfo.email }} 
                                   <i class='fas fa-check-circle text-success' v-if="userInfo.email_verified_at"></i> 
                                   <p class="small text-secondary m-0"  v-if="userInfo.email_verified_at">  {{  new Date(
                                      userInfo.email_verified_at
                                    ).toLocaleString()}}</p>
                                    <i v-else class='fas fa-times-circle text-danger'></i>
                                   
                                </td>
                                <td v-else> -</td>
                            
                              </tr>
                              <tr>
                                <th scope="row">Location :</th>
                                <td>{{ userInfo.location? userInfo.location : "-" }}</td>
                              </tr>
                              <tr>
                                <th scope="row">Referral Code :</th>
                                <td>{{ userInfo.referral_code }}</td>
                              </tr>
                              <tr>
                                <th scope="row">Referral By :</th>
                                  <td>{{ userInfo.referral_by? userInfo.referral_by : "-" }}</td>
                              </tr>
                            
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <!-- end card -->
                  </div>
                  <div class="col-xl-8">
                    <div class="row">
                      <div class="col-md-4">
                        <div class="card mini-stats-wid">
                          <div class="card-body">
                            <div class="media">
                              <div class="media-body">
                                <p class="fw-medium mb-2">Total Refferals</p>
                                <h4 class="mb-0">{{ totalRefferals }}</h4>
                              </div>
                              <div
                                class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary"
                              >
                                <span class="avatar-title"
                                  ><i
                                    class="bx bx-user font-size-24"
                                  ></i
                                ></span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="card mini-stats-wid">
                          <div class="card-body">
                            <div class="media">
                              <div class="media-body">
                                <p class="fw-medium mb-2">Total Deposit</p>
                                <h4 class="mb-0">{{ parseFloat(totalDeposit).toFixed(4) }}</h4>
                              </div>
                              <div
                                class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary"
                              >
                                <span class="avatar-title"
                                  ><i
                                    class="bx bx-purchase-tag-alt font-size-24"
                                  ></i
                                ></span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="card mini-stats-wid">
                          <div class="card-body">
                            <div class="media">
                              <div class="media-body">
                                <p class="fw-medium mb-2">Total Withdrawal</p>
                                <h4 class="mb-0">{{ parseFloat(totalWithdraw).toFixed(4) }}</h4>
                            
                              </div>
                              <div
                                class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary"
                              >
                                <span class="avatar-title"
                                  ><i
                                    class="bx bx-purchase-tag-alt font-size-24"
                                  ></i
                                ></span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="card mini-stats-wid">
                          <div class="card-body">
                            <div class="media">
                              <div class="media-body">
                                <p class="fw-medium mb-2">
                                  Today Total Withdrawal
                                </p>
                                <h4 class="mb-0">{{ parseFloat(totalTodayWithdraw).toFixed(4) }}</h4>
                            
                              </div>
                              <div
                                class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary"
                              >
                                <span class="avatar-title"
                                  ><i
                                    class="bx bx-purchase-tag-alt font-size-24"
                                  ></i
                                ></span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="card mini-stats-wid">
                          <div class="card-body">
                            <div class="media">
                              <div class="media-body">
                                <p class="fw-medium mb-2">Total Orders</p>
                                <h4 class="mb-0">{{ parseFloat(totalOrders).toFixed(4) }}</h4>
                            
                              </div>
                              <div
                                class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary"
                              >
                                <span class="avatar-title"
                                  ><i
                                    class="bx bx-purchase-tag-alt font-size-24"
                                  ></i
                                ></span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="card mini-stats-wid">
                          <div class="card-body">
                            <div class="media">
                              <div class="media-body">
                                <p class="fw-medium mb-2">Total Staking</p>
                                <h4 class="mb-0">{{ parseFloat(totalStaking).toFixed(4) }}</h4>
                            
                              </div>
                              <div
                                class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary"
                              >
                                <span class="avatar-title"
                                  ><i
                                    class="bx bx-purchase-tag-alt font-size-24"
                                  ></i
                                ></span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="card mini-stats-wid">
                          <div class="card-body">
                            <div class="media">
                              <div class="media-body">
                                <p class="fw-medium mb-2">Total Send Cryptos</p>
                                <h4 class="mb-0">{{ parseFloat(totalssendCryptos).toFixed(4) }}</h4>
                            
                              </div>
                              <div
                                class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary"
                              >
                                <span class="avatar-title"
                                  ><i
                                    class="bx bx-purchase-tag-alt font-size-24"
                                  ></i
                                ></span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="card mini-stats-wid">
                          <div class="card-body">
                            <div class="media">
                              <div class="media-body">
                                <p class="fw-medium mb-2">Total Received Cryptos</p>
                                <h4 class="mb-0">{{ parseFloat(totalsreceiveCryptos).toFixed(4) }}</h4>
                            
                              </div>
                              <div
                                class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary"
                              >
                                <span class="avatar-title"
                                  ><i
                                    class="bx bx-purchase-tag-alt font-size-24"
                                  ></i
                                ></span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- end row -->
              </b-tab>
              <b-tab>
                <template v-slot:title>
                  <span class="">
                    <i class="bx bx bxs-user-check "></i>
                  </span>
                  Kyc  <span class=" badge bg-light border"
                    > User</span
                  >
                </template>
                <div class="col-12" v-if="userKyc">
                  <div class="row">
                    <div class="col-6" v-if="userKyc.response_data">
                         <h6 class="text-dark">KYC AADHAAR API RESPONSE </h6>
                         <table class="table table-centered table-nowrap align-middle gap-3 table-bordered" cellpadding="10">
                          <tr>
                          <th>Name</th>
                          <td>{{userKyc.response_data.name}}</td>
                         </tr>
                         <tr>
                          <th>ref_id</th>
                          <td>{{userKyc.response_data.ref_id}}</td>
                         </tr>
                          <tr>
                          <th>status</th>
                          <td>{{userKyc.response_data.status}}</td>
                         </tr>
                         <tr>
                          <th>care_of</th>
                          <td>{{userKyc.response_data.care_of}}</td>
                         </tr>
                         <tr>
                          <th>dob</th>
                          <td>{{userKyc.response_data.dob}}</td>
                         </tr>
                         <tr>
                          <th>message</th>
                          <td>{{userKyc.response_data.message}}</td>
                         </tr>
                       
                         <tr>
                          <th>gender</th>
                          <td>{{userKyc.response_data.gender}}</td>
                         </tr>
                         <tr>
                          <th>Address</th>
                          <td><pre>{{userKyc.response_data.split_address}}</pre></td>
                         </tr>
                        
                         <tr>
                          <th>photo_link</th>
                          <td><img :src="'data:image/jpeg;base64,'+userKyc.response_data.photo_link"/></td>
                         </tr>
                        


                         </table>
                      
                    </div>
                    <div class="col-3">
                      Kyc Front
                      <img
                        v-b-modal.modal-1
                        @click="largeImg = userKyc.identity_front_path"
                        :src="userKyc.identity_front_path"
                        loading="lazy"
                        
                        class="img-fluid img-thumbnail"
                        alt="front_image"
                      />
                    </div>
                    <div class="col-3">
                      Kyc Back
                      <img
                        v-b-modal.modal-1
                        @click="largeImg = userKyc.identity_back_path"
                        :src="userKyc.identity_back_path"
                        loading="lazy"
                        class="img-fluid img-thumbnail"
                        alt="front_image"
                      />
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="alert alert-danger">KYC Not Found</div>

                </div>
              </b-tab>
              <b-tab>
                <template v-slot:title>
                  <span class="">
                    <i class="bx bx-wallet"></i>
                  </span>
                  Wallet <span class="badge bg-light border"
                    > Address</span
                  >
                </template>
                <div class="col-12">
                  <div v-for="wallet in walletInfo" :key="wallet.id">
                    <p class="p-3 border col-12 text-start">
                      <strong> {{ wallet.type }}</strong> <br />
                      {{ wallet.address }}
                    </p>
                  </div>
                </div>
              </b-tab>
              <b-tab @click="refresh()">
                <template v-slot:title>
                  <span class="">
                    <i class="bx bx-dollar"></i>
                  </span>
                  Wallet <span class="badge bg-light border"
                    > Balances</span
                  >
                </template>
                <div class="col-12">
                  <div class="user_data_list">
                    <simplebar>
                      <div class="table-responsive">
                        <table
                          class="table table-centered table-nowrap align-middle gap-3"
                        >
                          <thead>
                            <tr>
                              <th scope="col">#</th>
                              <th scope="col">Spot</th>
                              <th scope="col">Fund</th>
                              <th scope="col">Freeze</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-if="cryptoInfo && cryptoInfo.length == 0">
                              <td colspan="3">
                                <div
                                  class="
                              d-flex
                              justify-content-center
                              align-items-center
                            "
                                >
                                  <h5>No Record Found</h5>
                                </div>
                              </td>
                            </tr>

                            <tr
                              v-for="(data, index) in cryptoInfo"
                              :key="index"
                            >
                              <td style="width: 100px;">
                                <img
                                  :src="data.image"
                                  class="rounded-circle avatar-xs w-25 h-25"
                                  alt
                                />
                                {{ data.currency }}
                              </td>

                              <td>{{ data.balance }}</td>
                              <td>{{ data.fund_balance }}</td>
                              <td>{{ data.freezed_balance }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </simplebar>
                  </div>
                </div>
              </b-tab>
              <b-tab @click="refresh()">
                <template v-slot:title>
                  <span class="">
                    <i class="bx bx bx-list-ol"></i>
                  </span>
                  Deposit  <span class=" badge bg-light border"
                    > Trans</span
                  >
                </template>
                <div class="user_data_list">
                  <div class="table-responsive">
                    <table
                      class="table  table-centered table-nowrap align-middle"
                    >
                      <thead>
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col">Created At</th>
                          <th scope="col">Amount</th>
                          <th scope="col">Symbol</th>
                          <th scope="col">Blockchain</th>
                          <th scope="col">Status</th>
                          <th scope="col">User Address</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="depositTransactionInfo && depositTransactionInfo.length == 0">
                          <td colspan="5">
                            <div
                              class="
                            d-flex
                            justify-content-center
                            align-items-center
                          "
                            >
                              <h5>No Record Found</h5>
                            </div>
                          </td>
                        </tr>

                        <tr
                          v-for="(data, index) in depositTransactionInfo"
                          :key="index"
                        >
                          <td>
                            {{ index + 1 }}
                          </td>

                          <td>
                            {{ new Date(data.created_at).toLocaleString() }}
                          </td>

                          <td>{{ data.amount }}</td>
                          <td>{{ data.symbol }}</td>
                          <td>{{ data.chain_type }}</td>

                          <td>
                            <span
                              :class="
                                `badge bg-${
                                  data.status == 'completed'
                                    ? 'success'
                                    : 'warning'
                                }`
                              "
                              >{{ data.status }}</span
                            >
                          </td>
                          <td>{{ data.user_wallet_address }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </b-tab>
              <b-tab @click="refresh()">
                <template v-slot:title>
                  <span class="">
                    <i class="bx bx bx-list-ol"></i>
                  </span>
                  Withdraw  <span class=" badge bg-light border"
                    > Trans</span
                  >
                </template>
                <div class="user_data_list">
                  <div class="table-responsive">
                    <table
                      class="table table-centered table-nowrap align-middle"
                    >
                      <thead>
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col">Created At</th>
                          <th scope="col">Blockchain</th>
                          <th scope="col">To Address</th>
                          <th scope="col">Status</th>
                          <th scope="col">Amount</th>
                          <th scope="col">Fee</th>
                          <th scope="col">Total Amount</th>
                          <th scope="col">Trans Hash</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="walletTransactionInfo && walletTransactionInfo.length == 0">
                          <td colspan="5">
                            <div
                              class="
                            d-flex
                            justify-content-center
                            align-items-center
                          "
                            >
                              <h5>No Record Found</h5>
                            </div>
                          </td>
                        </tr>

                        <tr
                          v-for="(data, index) in walletTransactionInfo"
                          :key="index"
                        >
                          <td>
                            {{ index + 1 }}
                          </td>
                          <td>
                            {{ new Date(data.created_at).toLocaleString() }}
                          </td>
                          <td>{{ data.chain_type }}</td>
                          <td>{{ data.to_address }}</td>

                          <td>
                            <span
                              :class="
                                `badge bg-${
                                  data.status == 'completed'
                                    ? 'success'
                                    : 'warning'
                                }`
                              "
                              >{{ data.status }}</span
                            >
                          </td>

                          <td>
                            {{ data.amount }}
                          </td>
                          <td>
                         
                            <small class="fw-bold">{{ data.currency }}</small>
                          </td>
                          <td>
                            {{
                              parseFloat(data.amount) + parseFloat(data.extra)
                            }}
                            <small class="fw-bold">{{ data.currency }}</small>
                          </td>
                          <td>
                            {{
                              data.transfer_detail
                                ? data.transfer_detail.transaction
                                : ""
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div
                  class="text-center"
                  v-if="walletTransactionInfo && walletTransactionInfo.length > 5"
                >
                  <router-link to="/crypto/wallettransactions/ ">
                    <button type="button" class="btn btn-primary w-sm">
                      View More
                      <i class="mdi mdi-arrow-right ms-1"></i>
                    </button>
                  </router-link>
                </div>
              </b-tab>

              <b-tab @click="refresh()">
                <template v-slot:title>
                  <span class="">
                    <i class="bx bx bxs-lock "></i>
                  </span>
                  Staking  <span class=" badge bg-light border"
                    > hold</span
                  >
                </template>
                <div class="user_data_list">
                  <div class="table-responsive">
                    <table
                      class="table table-centered table-nowrap align-middle"
                    >
                      <thead>
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col">Currency</th>
                          <th scope="col">Amount</th>

                          <th scope="col">ROI Interval</th>
                          <th scope="col">ROI Income</th>
                          <th scope="col">Status</th>
                          <th scope="col">Plan Type</th>
                          <th scope="col">Activation Date</th>
                          <th scope="col">Expiry Date</th>
                          <th scope="col">Next Roi Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="stakingInfo && stakingInfo.length == 0">
                          <td colspan="5">
                            <div
                              class="
                            d-flex
                            justify-content-center
                            align-items-center
                          "
                            >
                              <h5>No Record Found</h5>
                            </div>
                          </td>
                        </tr>

                        <tr
                          v-for="(data, index) in stakingInfo"
                          :key="index"
                        >
                          <td>
                            {{ index + 1 }}
                          </td>
                          <td>{{ data.stake_currency }}</td>
                          <td>{{ data.amount }}</td>
                           <td>{{ data.roi_interval }}</td>
                           <td>{{ data.roi_income }}</td>

                          <td>
                            <span v-if="!data.unactive_at"
                              :class="
                                `badge bg-${
                                  data.is_active == 1
                                    ? 'success'
                                    : 'warning'
                                }`
                              "
                              >{{  data.is_active == 1 ? "active" : "inactive" }}</span
                            >
                            <span v-else
                              class="
                                badge bg-secondary
                              "
                              >expired</span
                            >
                          </td>

                          <td>{{ data.plan_type }}</td>

                         
                         
                          <td>
                            {{ new Date(data.activation_date).toLocaleString() }}
                          </td>
                              <td>
                            {{ new Date(data.expiry_date).toLocaleString() }}
                          </td>
                              <td>
                            {{ new Date(data.next_roi_date).toLocaleString() }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div
                  class="text-center"
                  v-if="walletTransactionInfo && walletTransactionInfo.length > 5"
                >
                  <router-link to="/crypto/wallettransactions/ ">
                    <button type="button" class="btn btn-primary w-sm">
                      View More
                      <i class="mdi mdi-arrow-right ms-1"></i>
                    </button>
                  </router-link>
                </div>
              </b-tab>

              <b-tab>
                <template v-slot:title>
                  <span>
                  <i class="bx bx bx-server"></i>
                  </span>
                  Orders <span class="badge bg-light border"
                    > Trades</span>
                </template>
                <div class="table-responsive">
                  <table class="table table-centered table-nowrap align-middle">
                    <thead>
                      <tr class="align-middle">
                        <th style="width: 50px" scope="col">Type</th>
                        <th scope="col">Currency</th>
                        <th scope="col">
                          <div>
                            <h5 class="font-size-14 mb-0">
                              Qty/<span>Price</span>
                            </h5>
                          </div>
                        </th>
                        <th scope="col">Total</th>
                        <th scope="col">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="ordersInfo && ordersInfo.length == 0">
                        <td colspan="5">
                          <div
                            class="d-flex justify-content-center align-items-center"
                          >
                            <h5>No Record Found</h5>
                          </div>
                        </td>
                      </tr>
                      <tr v-for="(data, index) of ordersInfo" :key="index">
                        <td style="width: 50px">
                          <div
                            :class="
                              `font-size-22 text-${
                                data.order_type == 'buy' ? 'success' : 'danger'
                              }`
                            "
                          >
                            <i
                              :class="{
                                'bx bx-down-arrow-circle':
                                  `${data.order_type}` === 'buy',
                                'bx bx-up-arrow-circle':
                                  `${data.order_type}` === 'sell',
                              }"
                            ></i>
                          </div>
                        </td>
                        <td>
                          <div>
                            <h5 class="font-size-14 mb-1">
                              {{ data.currency }}/<span>{{
                                data.with_currency
                              }}</span>
                            </h5>
                            <p class="text-muted mb-0">
                              {{ new Date(data.created_at).toLocaleString() }}
                            </p>
                          </div>
                        </td>
                        <td>
                          <div>
                            <h5 class="font-size-14 mb-1">
                              {{ data.quantity }}
                            </h5>
                            <p class="text-muted mb-0">{{ data.at_price }}</p>
                          </div>
                        </td>
                        <td>{{ data.total }}</td>
                        <td>{{ data.current_status }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="text-center" v-if="ordersInfo && ordersInfo.length > 5">
                  <router-link :to="'/crypto/orders/' + id">
                    <button type="button" class="btn btn-primary w-sm">
                      View More
                      <i class="mdi mdi-arrow-right ms-1"></i>
                    </button>
                  </router-link>
                </div>
              </b-tab>
              <b-tab>
                <template v-slot:title>
                  <span>
                  <i class="bx bx bx-history"></i>
                  </span>
                  Activity <span class="badge bg-light border"
                    > Logs</span>
                </template>
                <div class="table-responsive">
                  <table class="table table-centered table-nowrap align-middle">
                    <thead>
                      <tr class="align-middle">
                        <th style="width: 50px" scope="col">Type</th>
                        <th scope="col">IP</th>
                       
                        <th scope="col">Message</th>
                        <th scope="col">Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="ActivityLogsInfo && ActivityLogsInfo.length == 0">
                        <td colspan="5">
                          <div
                            class="d-flex justify-content-center align-items-center"
                          >
                            <h5>No Record Found</h5>
                          </div>
                        </td>
                      </tr>
                      <tr v-for="(data, index) of ActivityLogsInfo" :key="index">
                        <td style="width: 50px">
                         {{ data.type }}
                        </td>
                       
                        <td>{{ data.ip }}</td>
                        <td>{{ data.message }}</td>
                        <td>{{
                new Date(data.created_at).toLocaleDateString()
              }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
             
              </b-tab>
              <b-tab>
                <template v-slot:title>
                  <span>
                  <i class="bx bx bx-history"></i>
                  </span>
                  Send Crypto <span class="badge bg-light border"
                    > P2P</span>
                </template>
                <div class="table-responsive">
                  <table class="table table-centered table-nowrap align-middle">
                    <thead>
                      <tr class="align-middle">
                        <th style="width: 50px" scope="col">wallet type</th>
                        <th scope="col">to user</th>
                        <th scope="col">to user type</th>
                        <th scope="col">to user value</th>
                       
                        <th scope="col">amount</th>
                        <th scope="col">currency</th>
                        <th scope="col">Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="totalsendCryptos && totalsendCryptos.length == 0">
                        <td colspan="5">
                          <div
                            class="d-flex justify-content-center align-items-center"
                          >
                            <h5>No Record Found</h5>
                          </div>
                        </td>
                      </tr>
                      <tr v-for="(data, index) of totalsendCryptos" :key="index">
                        <td style="width: 50px">
                         {{ data.wallet_type }}
                        </td>
                       
                     
                        <td>
                          <router-link
                          :to="'/users/list/' + data.to_user"
                          
                          >{{ data.to_user }} <i class="fa fa-link"></i>
                        </router-link>
                        </td>
                        <td>{{ data.to_user_type }}</td>
                        <td>{{ data.to_user_value }}</td>
                        <td>{{ data.amount }}</td>
                        <td>{{ data.currency }}</td>
                        <td>{{
                new Date(data.created_at).toLocaleDateString()
              }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
             
              </b-tab>
              <b-tab>
                <template v-slot:title>
                  <span>
                  <i class="bx bx bx-history"></i>
                  </span>
                  Receive Crypto <span class="badge bg-light border"
                    > P2P</span>
                </template>
                <div class="table-responsive">
                  <table class="table table-centered table-nowrap align-middle">
                    <thead>
                      <tr class="align-middle">
                        <th style="width: 50px" scope="col">wallet type</th>
                        <th scope="col">from user</th>
                        <th scope="col">to user type</th>
                        <th scope="col">to user value</th>
                       
                        <th scope="col">amount</th>
                        <th scope="col">currency</th>
                        <th scope="col">Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="totalreceiveCryptos && totalreceiveCryptos.length == 0">
                        <td colspan="5">
                          <div
                            class="d-flex justify-content-center align-items-center"
                          >
                            <h5>No Record Found</h5>
                          </div>
                        </td>
                      </tr>
                      <tr v-for="(data, index) of totalreceiveCryptos" :key="index">
                        <td style="width: 50px">
                         {{ data.wallet_type }}
                        </td>
                       
                     
                        <td>
                          <router-link
                          :to="'/users/list/' + data.user_id"
                          
                          >{{ data.user_id }} <i class="fa fa-link"></i>
                        </router-link>
                        </td>
                        <td>{{ data.to_user_type }}</td>
                        <td>{{ data.to_user_value }}</td>
                        <td>{{ data.amount }}</td>
                        <td>{{ data.currency }}</td>
                        <td>{{
                new Date(data.created_at).toLocaleDateString()
              }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
             
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>

    <!-- Large Image Modal -->
    <b-modal id="modal-1" size="xl" v-if="largeImg">
      <b-row align-v="center">
        <img
          :src="largeImg"
          loading="lazy"
          class="img-fluid img-thumbnail"
          alt="front_image"
        />
      </b-row>
      <template #modal-footer>
        <p></p>
      </template>
    </b-modal>
  </Layout>
</template>
<style>
.card.users_wallet_card {
  min-height: 355px !important;
  height: auto !important;
}
</style>
